import { useState, SyntheticEvent } from 'react';
import { TabsProps as MuiTabsProps } from '@mui/material/Tabs';
import { StyledTabs } from './styles';

export interface TabsProps extends Omit<MuiTabsProps, 'value'> {
  defaultValue?: string | number;
}

export default function Tabs(props: TabsProps) {
  const {
    defaultValue,
    variant = 'fullWidth',
    onChange,
    children,
    ...tabsProps
  } = props;
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);

    if (onChange) {
      onChange(event, newValue);
    }
  };

  return (
    <StyledTabs
      variant={variant}
      {...tabsProps}
      value={value}
      onChange={handleChange}
    >
      {children}
    </StyledTabs>
  );
}
